import { isValidElement } from 'react';
import type { ReactNode } from 'react';

/**
 * Texte brut d’un titre React (react-markdown peut passer un tableau de nœuds).
 */
export function reactNodeToPlainText(node: ReactNode): string {
    if (node == null || typeof node === 'boolean') return '';
    if (typeof node === 'string' || typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map(reactNodeToPlainText).join('');
    if (isValidElement(node)) {
        const ch = (node.props as { children?: ReactNode }).children;
        if (ch != null) return reactNodeToPlainText(ch);
    }
    return '';
}

/**
 * Aligné sur `BlogRepository._generate_toc` (Python) : minuscules, retire la ponctuation
 * hors lettres/chiffres/underscore/espaces/tirets, puis espaces → tiret.
 */
export function slugifyBlogHeadingSource(text: string): string {
    const t = text.trim().toLowerCase();
    const noPunct = t.replace(/[^\p{L}\p{N}_\s-]/gu, '');
    return noPunct.replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
}
